import styled from 'styled-components';
import { DotBadge } from '../badge/DotBadge';

interface TabProps {
  isActive: boolean;
  text: string;
  handleClick: () => void;
  hasNotification?: boolean;
}

export const Tab = ({ isActive, text, handleClick, hasNotification }: TabProps) => {
  return (
    <Container onClick={handleClick}>
      <TabTextContainer>
        <TabText isActive={isActive}>{text}</TabText>
        {hasNotification && <DotBadge style={{ right: '-8.5px' }} />}
      </TabTextContainer>
    </Container>
  );
};

const Container = styled.button`
  min-width: 80px;
  height: 28px;

  display: flex;
  justify-content: center;
  align-items: center;

  flex: 1 0 0;
  gap: 10px;

  transition: all 0.3s ease;
`;

const TabTextContainer = styled.div`
  position: relative;
`;

const TabText = styled.span<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? '#232429' : '#A7A9B6')};
  text-align: center;

  /* System/Medium/m-bold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 11.9px */
`;
